<template>
  <div class="header-container">
    <el-row
      type="flex"
      align="middle"
      justify="space-between"
      style="width: 100%"
    >
      <!-- 左侧标题 -->
      <el-col :span="4" style="min-width: 200px">
        <div class="title">
          <el-image
            style="width: 32px; height: 32px"
            :src="logo"
            fit="fill"
          ></el-image>
          <!-- <span>{{ name }}</span> -->
          <el-image
            style="width: 100px; height: 32px; margin-left: 10px"
            :src="logoTitle"
            fit="fill"
          ></el-image>
        </div>
      </el-col>

      <!-- 右侧操作区 -->
      <el-col :span="8" style="min-width: 500px">
        <div class="right-menu">
          <div
            class="qr-hover-wrapper"
            @mouseenter="showServiceQR = true"
            @mouseleave="showServiceQR = false"
          >
            <el-link type="info" :underline="false">
              <div style="display: flex; align-items: center">
                <el-image
                  style="width: 20px; height: 20px"
                  :src="require('@/assets/images/connect.png')"
                  fit="fill"
                >
                </el-image>
                <span>联系客服</span>
              </div>
            </el-link>
            <transition name="fade">
              <div class="qr-popup" v-if="showServiceQR">
                <img :src="kefuCode" alt="客服二维码" />
                <p>扫码联系客服</p>
              </div>
            </transition>
          </div>

          <div
            class="qr-hover-wrapper"
            @mouseenter="showMiniQR = true"
            @mouseleave="showMiniQR = false"
          >
            <el-link type="info" :underline="false">
              <div style="display: flex; align-items: center">
                <el-image
                  style="width: 20px; height: 20px"
                  :src="require('@/assets/images/xcx.png')"
                  fit="fill"
                />
                <span>小程序</span>
              </div>
            </el-link>
            <transition name="fade">
              <div class="qr-popup" v-if="showMiniQR">
                <img :src="miniProgramCode" alt="小程序二维码" />
                <p>打开小程序</p>
              </div>
            </transition>
          </div>

          <!-- 昵称与退出 -->
          <span class="nickname">昵称:{{ nickname }}</span>
          <el-divider direction="vertical" />
          <el-link @click="logout()" type="info" :underline="false"
            >退出</el-link
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/index.js";
import config from "@/utils/config";

export default {
  data() {
    return {
      nickname: "",
      showServiceQR: false,
      showMiniQR: false,
      logo: config.logo,
      name: config.name,
      logoTitle: config.logoTitle,
      miniProgramCode: config.miniProgramCode,
      kefuCode: config.kefuCode,
    };
  },
  mounted() {
    console.log("mountedmountedmountedmounted");
    this.getMessage();
  },
  methods: {
    async getMessage() {
      // const res = await getUserInfo( localStorage.getItem('token'))
      getUserInfo(localStorage.getItem("token"))
        .then((res) => {
          this.nickname = res.data.nickname;
          localStorage.setItem("nickname", res.data.nickname);
          localStorage.setItem("ifTencentDocs", res.data.ifTencentDocs);
          localStorage.setItem("ifFeiShuDocs", res.data.ifFeiShuDocs);
          localStorage.setItem("tencentDocsExpiry", res.data.tencentDocsExpiry);
          localStorage.setItem("feishuDocsExpiry", res.data.feishuDocsExpiry);
          localStorage.setItem("openId", res.data.openidId);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    logout() {
      localStorage.removeItem("token");
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.header-container {
  padding: 0 20px;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  display: flex;
  align-items: center;
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;

  span {
    margin-left: 8px;
  }
}

.right-menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  position: relative;
}

.qr-hover-wrapper {
  position: relative;
}

.qr-popup {
  position: absolute;
  top: 40px;
  left: 0;
  background: white;
  padding: 10px;
  width: 140px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  text-align: center;
}

.qr-popup img {
  width: 120px;
  height: 120px;
}

.qr-popup p {
  font-size: 14px;
  color: #666;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.el-link {
  font-size: 14px;
  color: #666 !important;

  span {
    margin-left: 8px;
  }
}

.el-link:hover {
  color: #409eff !important;
}

.nickname {
  font-size: 14px;
  color: #666;
  margin: 0 5px;
}

.el-divider--vertical {
  /* margin: 0 8px; */
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/myHeader.vue